import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Tooltip, Skeleton } from "antd";
import {
    CloseOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { CommonContainer } from "./styles";
import { useTranslation } from "react-i18next";
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import { useSelector } from "react-redux";
import { AwardLists } from "pages/AwardList/styles";
import { WinningCard } from "pages/Homepage/styles";
import { Label } from "assets/styles/globalStyles";
import { FontSizes, FontWeight } from "utils/enums";
import { colors } from "assets/styles/colors";


const BooksModal = (props: any) => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const { onClose, open, location } = props;
    const containerBody = useRef<HTMLDivElement>(null);
    const [articles, setBooks] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleOnClickBook = (id: any) => {
        navigate(`/book/${id}`)
        onClose();
    }

    useEffect(() => {
        if (open) {
            fetchBooks();
        }
    }, [open, location]);

    const fetchBooks = async () => {
        setIsLoading(true)
        const res = await fetchData(restAPIs.bookByLocation(currentLang?.id, location.latitude, location.longitude));
        setIsLoading(false)
        if (res?.statusCode === 200) {
            setBooks(res.books);
        }
    };


    return (
        <>
            <Modal open={open} onCancel={onClose} footer={null} width={900} centered
                keyboard={false}
                closable={false}
                maskClosable={false}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'25px', marginTop:'10px', borderBottom: '1px solid #E5E5E5'}}>
                <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h2}>{t("books")}</Label>
                    <Button type="text" icon={<CloseOutlined />} onClick={onClose} style={{ fontSize: 20 }} />
                </div>
                <CommonContainer>
                    {isLoading ? (
                        <AwardLists>
                            {Array.from({ length: 3 }).map((_, i) => (
                                <WinningCard key={i}>
                                    <Skeleton.Image active style={{ width: '170px', height: '170px' }} />
                                    <Skeleton active paragraph={{ rows: 2 }} />
                                </WinningCard>
                            ))}
                        </AwardLists>
                    ) : (
                        <AwardLists>
                            {articles && articles.map((item: any, i: any) => (
                                <WinningCard key={i} onClick={() => handleOnClickBook(item.bookid)} style={{ cursor: 'pointer' }}>
                                    <div className="book">
                                        <div className="cover" style={{ backgroundImage: `url(${item.coverImage})` }}></div>
                                        <div className="__category">{item.subjectName}</div>
                                    </div>
                                    <div className="__content">
                                        <Tooltip title={item.name}>
                                            <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h2} marginBottom={15}>
                                                {item.name}
                                            </Label>
                                        </Tooltip>
                                        <Tooltip title={`${item.author}`}>
                                            <p className="__author">{item.author}</p>
                                        </Tooltip>
                                        <Tooltip title={` ${item.subjectName}`}>
                                            <p>{item.subjectName}</p>
                                        </Tooltip>
                                        <Tooltip title={<span dangerouslySetInnerHTML={{ __html: item.addinfo }} />}>
                                            <p className="__author" dangerouslySetInnerHTML={{ __html: item.addinfo }}></p>
                                        </Tooltip>
                                    </div>
                                </WinningCard>
                            ))}
                        </AwardLists>
                    )}
                </CommonContainer>
            </Modal>
        </>
    );
};

export default BooksModal;
